import React from "react";

const RichText = (props) => {
    const { className, ...others } = props;
    const css = `mt-2 ${className ?? ""}`;

    return (
        <>
            {props.items &&
                props.items.map((t, i) =>
                    t.type === "html" ? (
                        <p
                            key={i}
                            className={css}
                            {...others}
                            dangerouslySetInnerHTML={{ __html: t.value }}
                        ></p>
                    ) : (
                        <p key={i} className={css} {...others}>
                            {t.value}
                        </p>
                    )
                )}
        </>
    );
};

export default RichText;
